import { getInvoiceList } from "api/invoice_list";
import { APIListData } from "api/types";
import { AxiosError } from "axios";
import { Invoice } from "models";
import { useState } from "react";
import { useQuery } from "react-query";
import { TInvoiceFilter } from "types/TInvoiceFilter";
import { TSearchParamsRequired } from "types/TSearchParams";

const useLoadInvoices = ({
  searchParams
}: {
  searchParams: TSearchParamsRequired<TInvoiceFilter>;
}) => {
  const [count, setCount] = useState(0);

  const { isLoading, error, data, refetch } = useQuery<APIListData<Invoice>, AxiosError>({
    queryKey: [
      "invoice_list",
      searchParams.page,
      searchParams.page_size,
      searchParams.search,
      searchParams.filter,
      searchParams.ordering
    ],
    queryFn: () =>
      getInvoiceList({
        page: searchParams.page,
        size: searchParams.page_size,
        search: searchParams.search,
        filter: searchParams.filter,
        ordering: searchParams.ordering
      }),
    retry: (failureCount, error) => {
      if (error.response?.status === 404) {
        return false;
      }
      return failureCount < 3;
    },
    refetchOnWindowFocus: false,
    onSuccess: ({ data }) => {
      if (data.count !== count) setCount(data.count);
    }
  });

  return {
    count,
    isLoading,
    error,
    refetch,
    invoices: data?.data?.results || ([] as Invoice[])
  };
};

export default useLoadInvoices;
